<template>
  <div>
    <div style="margin-bottom: 20px; font-size: 14px; display: flex; align-items: center;">
      <span>数据检测功能的状态：</span>
      <el-switch v-model="isAuditEnabled" @change="onSwitchAuditStatus">
      </el-switch>
    </div>

    <div style="margin-bottom: 20px">
      <el-button type="primary" icon="el-icon-plus" @click="openDialog(true, null)">新增检测项</el-button>
      <el-button style="margin-left: 20px" type="primary" icon="el-icon-document-copy"
        :disabled="this.selectionList.length == 0" @click="copyToClipboard()">复制到剪贴板</el-button>
      <el-button type="primary" icon="el-icon-document-add" @click="addFromClipboard()">从剪贴板添加</el-button>
    </div>

    <el-table @select="select" @select-all="select" :data="list" border size="small" style="width: 1431px"
      height="600px">
      <el-table-column fixed="left" type="selection" width="48">
      </el-table-column>
      <el-table-column fixed="left" prop="id" label="ID" align="center" width="80">
      </el-table-column>
      <el-table-column fixed="left" prop="isCheck" label="启用本配置" align="center" width="60">
        <template slot-scope="scope">
          <span v-if="!scope.row.isCheck" style="">否</span>
          <span v-if="scope.row.isCheck">是</span>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="minPaidYuan" label="付费金额不超过(元)" align="center" width="80">
      </el-table-column>
      <el-table-column fixed="left" prop="minPlayedDays" label="创角不超过(天)" align="center" width="80">
      </el-table-column>
      <el-table-column sortable fixed="left" prop="itemId" label="道具ID" align="center" width="100">
      </el-table-column>
      <el-table-column sortable fixed="left" prop="itemName" label="道具名称" align="center" width="200">
      </el-table-column>
      <el-table-column prop="mustBuyPayProduct" label="必须购买过的付费项" align="center" width="230" show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            scope.row.mustBuyPayProduct == 0
              ? ""
              : attachments[scope.row.mustBuyPayProduct]
          }}
        </template>
      </el-table-column>

      <el-table-column prop="fromPayProductReward" label="必须购买过包含该道具的任意付费项" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.fromPayProductReward" style="">否</span>
          <span v-if="scope.row.fromPayProductReward">是</span>
        </template>
      </el-table-column>
      <el-table-column prop="archiveLocation" label="在存档中的位置" align="center" width="300" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="valueType" label="在存档中的数值类型" align="center" width="130">
      </el-table-column>
      <el-table-column prop="maxNumber" label="数值阈值" align="center" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="isBlackList" label="拉进黑名单" align="center" width="85">
        <template slot-scope="scope">
          <span v-if="!scope.row.isBlackList" style="">否</span>
          <span v-if="scope.row.isBlackList">是</span>
        </template>
      </el-table-column>
      <el-table-column prop="isGreyList" label="拉进灰名单" align="center" width="85">
        <template slot-scope="scope">
          <span v-if="!scope.row.isGreyList" style="">否</span>
          <span v-if="scope.row.isGreyList">是</span>
        </template>
      </el-table-column>

      <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center" width="150">
      </el-table-column>

      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <span class="link-button" style="color: red" @click="remove(scope.row)">删除</span>
          <span class="link-button" @click="openDialog(false, scope.row)">编辑</span>
          <span class="link-button" @click="openDialog(true, scope.row)">复制</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      isAuditEnabled: false,
      list: [], //
      attachments: {},
      selectionList: [],
    };
  },

  async mounted() {
    await this.loadList();
    this.attachments = await this.$bizutil.loadAttachments(true);
  },

  methods: {
    async onSwitchAuditStatus(val) {
      // 先将开关状态还原
      this.isAuditEnabled = !val;

      // 将期望的开关状态保存到服务器
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/dataMonitor/updateEnableStatus`,
          {
            isEnabled: val,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      // 最后调整开关状态
      this.isAuditEnabled = val;
    },

    select(selection, row) {
      this.selectionList = selection;
    },

    /**
     *
     */
    async loadList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/dataMonitor/queryAll`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = listInResponse;
      this.isAuditEnabled = resData.data.isEnabled;
    },

    /**
     *
     */
    openDialog(isCreate, oldData) {
      dialogutil.open("EditDataMonitorDialog", {
        closedCallback: () => {
          this.loadList();
        },
        data: { isCreate: isCreate, entry: oldData },
      });
    },

    /**
     * 删除
     */
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除ID为${entry.id}的检测项？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/dataMonitor/delete`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) { }
    },
    /**
     * 复制到剪贴板
     */
    async copyToClipboard() {
      if (this.selectionList.length == 0) {
        this.$message({
          message: "未选中任何可复制内容",
          type: "warning",
        });
      }
      try {
        await navigator.clipboard.writeText(
          JSON.stringify({ copyDataMonitors: this.selectionList })
        );
        this.$message({
          message: "复制成功",
          type: "success",
        });
      } catch (err) {
        this.$message.error("复制失败： " + JSON.stringify(err));
      }
    },

    async addFromClipboard() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增配置？`);
      } catch (error) {
        return;
      }

      let addFunc = async (val) => {
        try {
          let resData = (
            await axios.post(
              `${this.$util.getBackendApiBase()}/v1/admin/dataMonitor/add`,
              { entry: val },
              {
                headers: {
                  token: this.$bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message.error(resData.message);
            return;
          }

          // 弹确认框
          await this.$confirm(`添加成功`);

          // 关闭当前对话框
          this.onClose();
        } catch (e) { }
      };
      let result = await navigator.permissions.query({
        name: "clipboard-read",
      });

      if (result.state === "granted" || result.state === "prompt") {
        // 可以使用权限
        // 进行clipboard的操作
        let text = await navigator.clipboard.readText();

        let obj = JSON.parse(text).copyDataMonitors;
        if (obj) {
          for (let i = 0; i < obj.length; i++) {
            let item = obj[i];
            await addFunc(item);
          }

          this.selectionList = [];
          this.loadList();
        }
      } else if (result.state === "denied") {
        alert("已禁止访问粘贴板，请手动开启权限");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__row td {
  padding: 0px 0;
}

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}
</style>